export const FirebaseConfig = {
	"projectId": "bodrumcab",
	"appId": "1:608156495752:web:e024bc18a2ee479c38943d",
	"databaseURL": "https://bodrumcab-default-rtdb.europe-west1.firebasedatabase.app",
	"storageBucket": "bodrumcab.firebasestorage.app",
	"apiKey": "AIzaSyDp6l-LPMXmHnreR-klc-_l26hg4TqFZKE",
	"authDomain": "bodrumcab.firebaseapp.com",
	"messagingSenderId": "608156495752"
};